var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71433 0L0.065635 5.9235H1.28074L0 12L5.03782 4.9378H4.00706L4.91451 1.77522L6.99665 1.7799H7.02816C7.96125 1.7799 8.71767 2.48682 8.71767 3.35885C8.71767 4.13221 8.12275 4.77571 7.33727 4.91143L7.22433 4.92727C7.15998 4.93422 7.09451 4.9378 7.02816 4.9378H6.95842V6.68665H7.27583C8.0613 6.82238 8.65623 7.46587 8.65623 8.23923C8.65623 9.02941 8.03515 9.68401 7.22433 9.79994L6.08157 9.82287L4.83177 11.5458C5.03746 11.5802 5.24924 11.5981 5.46551 11.5981H7.42256C9.39832 11.5981 11 10.1012 11 8.25476C11 7.28397 10.5573 6.40982 9.85021 5.79904C10.5573 5.18825 11 4.31411 11 3.34333C11 1.49686 9.39831 0 7.42254 0H1.71433Z",
    fill: "#4A25A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9de319ffbd392235e4a06ff3d3600b77.svg";
export { ForwardRef as ReactComponent };